import store from "../../redux/store";
import { toastr } from "react-redux-toastr";
import {
  clearData,
  logoutCall,
  setCurrentUser,
  refreshAuthCall,
} from "../../redux/actions/authActions";

export const getRefreshToken = (isClearData) => {
  if (localStorage.refreshToken) {
    const refTokenObj = JSON.parse(localStorage.refreshToken);
    const token = refTokenObj?.token || "";
    const expires = refTokenObj?.expires;

    if (expires?.length > 0 && new Date(`${expires}`) < Date.now()) {
      // refreshToken expires
      store.dispatch(isClearData ? clearData() : logoutCall());
      toastr.error("Refresh token expired", "Please log in again.");
      return "";
    }

    if (!token) {
      store.dispatch(isClearData ? clearData() : logoutCall());
      toastr.error("Refresh Token Not found", "Please log in again.");
      return "";
    }

    return token;
  }
};

const checkForAuthRefreshToken = (resolve, reject) => {
  if (localStorage.refreshToken) {
    const refTokenObj = JSON.parse(localStorage.refreshToken);
    const token = refTokenObj?.token;
    const expires = refTokenObj?.expires;

    if (expires?.length && new Date(`${expires}`) < Date.now()) {
      // refreshToken expires
      store.dispatch(logoutCall());
      toastr.error("Refresh token expired", "Please log in again.");
      return reject("Refresh token expires");
    } else {
      if (!token) {
        store.dispatch(logoutCall());
        toastr.error("Refresh token not found", "Please log in again.");
        return reject("Refresh token not found");
      }

      store.dispatch(
        refreshAuthCall({
          refreshToken: token,
        })
      );
    }
  } else {
    store.dispatch(logoutCall());
    return reject("Refresh token not exist");
  }
};

// fires on initial start of app

export const checkAuthOnHome = () => {
  return new Promise((resolve, reject) => {
    if (localStorage?.accessToken) {
      const tokenObj = JSON.parse(localStorage?.accessToken);
      const { expires } = tokenObj;

      if (new Date(`${expires}`) < Date.now()) {
        // send req for refresh token
        checkForAuthRefreshToken(resolve, reject);
      } else {
        store.dispatch(setCurrentUser(tokenObj));
        return resolve("success");
      }
    }
    return resolve("success");
  });
};
